module.exports = __webpack_public_path__ + "img/2.c3f0d85d.jpg";